import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { provideTranslocoScope } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import { DateSelectionValue } from '@platform-frontend/ui-tools';
import { CHECKOUT_MATOMO_EVENT_CATEGORY_PURCHASE } from '../../checkout-matomo-events';
import { CHECKOUT_TRANSLOCO_SCOPE } from '../../checkout-transloco-scope';
import { SelectLicenseValidity } from '../shopping-cart.actions';
import { ValidityConfigurationOption } from './model/validity-configuration-option';
import { ShoppingCartConfiguratorService } from './shopping-cart-configurator.service';

interface ShoppingCartConfigurationForm {
  validityDate: FormControl<DateSelectionValue>;
}

@Component({
  selector: 'yat-shopping-cart-configurator',
  templateUrl: './shopping-cart-configurator.component.html',
  styleUrls: ['./shopping-cart-configurator.component.scss'],
  providers: [provideTranslocoScope(CHECKOUT_TRANSLOCO_SCOPE), ShoppingCartConfiguratorService]
})
export class ShoppingCartConfiguratorComponent implements OnInit {
  constructor(private readonly shoppingCartConfiguratorService: ShoppingCartConfiguratorService, private store: Store) {}

  @Output()
  closeEvent = new EventEmitter<void>();

  readonly MATOMO_EVENT_CATEGORY_PURCHASE = CHECKOUT_MATOMO_EVENT_CATEGORY_PURCHASE;

  shoppingCartConfigurationForm = new FormGroup<ShoppingCartConfigurationForm>({
    validityDate: new FormControl<DateSelectionValue>(null, { nonNullable: true })
  });

  validityConfigurationOption: ValidityConfigurationOption | null = null;

  ngOnInit(): void {
    this.validityConfigurationOption = this.shoppingCartConfiguratorService.getValidityConfigurationOption();

    if (!this.validityConfigurationOption) {
      return;
    }

    this.shoppingCartConfigurationForm.setValue({ validityDate: this.shoppingCartConfiguratorService.getSelectedValidityDate() });
  }

  saveConfiguration(value: { validityDate: DateSelectionValue }): void {
    if (value.validityDate && value.validityDate !== 'INVALID') {
      this.store.dispatch(new SelectLicenseValidity({ date: value.validityDate, granularity: 'MONTH', duration: 'UNLIMITED', asOfNow: false }));
    }
    this.close();
  }

  close(): void {
    this.closeEvent.emit();
  }
}
